// extracted by mini-css-extract-plugin
export default {"container":"ParseResult-container-pfU9F","column":"ParseResult-column-v9q7Q"};